var _path, _rect, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 32,
    viewBox: "0 0 99 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5352 24H57.0977V20.6953H46.0234V16.9453H56.3359V13.9336H46.0234V10.3945H57.0977V7.08984H41.5352V24ZM59.9102 24H64.3984V18.1992H69.2969C69.3359 18.1992 69.3711 18.1992 69.4023 18.1992C69.4414 18.1992 69.4766 18.1992 69.5078 18.1992L73.082 24H78.1797L73.9609 17.4844C75.1172 17.1094 76 16.4961 76.6094 15.6445C77.2266 14.7852 77.5352 13.7539 77.5352 12.5508V12.5273C77.5352 11.3867 77.2734 10.4141 76.75 9.60938C76.2266 8.79688 75.457 8.17578 74.4414 7.74609C73.4258 7.30859 72.1797 7.08984 70.7031 7.08984H59.9102V24ZM64.3984 15.1523V10.3125H70.2578C71.1172 10.3125 71.793 10.5273 72.2852 10.957C72.7773 11.3867 73.0234 11.9727 73.0234 12.7148V12.7383C73.0234 13.4961 72.7812 14.0898 72.2969 14.5195C71.8203 14.9414 71.1523 15.1523 70.293 15.1523H64.3984ZM82.5039 18.9492H90.625C92.0469 18.9492 93.2695 18.6992 94.293 18.1992C95.3242 17.6992 96.1172 17.0039 96.6719 16.1133C97.2266 15.2227 97.5039 14.1914 97.5039 13.0195V12.9961C97.5039 11.8164 97.2266 10.7852 96.6719 9.90234C96.1172 9.01172 95.3242 8.32031 94.293 7.82812C93.2695 7.33594 92.0469 7.08984 90.625 7.08984H82.5039V10.3945H89.875C90.8672 10.3945 91.6289 10.625 92.1602 11.0859C92.6914 11.5391 92.957 12.1914 92.957 13.043V13.0664C92.957 13.9258 92.6914 14.5859 92.1602 15.0469C91.6289 15.5 90.8672 15.7266 89.875 15.7266H82.5039V18.9492ZM80.2539 24H84.7422V7.08984H80.2539V24Z",
    fill: "#172B4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#2151C5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 4,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 4,
    fill: "#0E7AE7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 16,
    r: 4,
    fill: "#B1D8FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 24,
    r: 4,
    fill: "#4399EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.29edd680860ee33c67b5f12acb75ccaf.svg";
export { ForwardRef as ReactComponent };